export default {
  '星期一': 'Monday',
  '星期二': 'Tuesday',
  '星期三': 'Wednesday',
  '星期四': 'Thursdday',
  '星期五': 'Friday',
  '星期六': 'Saturday',
  '星期日': 'Sunday',
  '上午': 'Morning',
  '下午': 'Afternoon',
  '晚上': 'Night',
  '凌晨': 'Midnight',
  '{nickname} {nowTimeCall}好，当前的时间为：{nowTime}': '{nickname} {nowTimeCall} hello，Now time：{nowTime}',
  '{year}年{month}月{day}日 {hour}:{minute}:{second} {week}': '{year}-{month}{day} {hour}:{minute}:{second} {week}',
  '管理员': 'Admins',
  '附件': 'Attachments',
  '启用扩展': 'Extensions',
  '管理分组': 'Groups',
  '系统信息': 'System Info',
  '当前版本': 'Version',
  '服务器域名/IP': 'Server domain/ip',
  '服务器信息': 'Server Info',
  '服务器环境': 'Server Env',
  'PHP 版本': 'PHP Version',
  'MySQL 版本': 'MySQL Version',
  '最大上传限制': 'Max Upload',
  '服务器时间': 'Server Time'
}
